import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

import { SubscriptionApplicationsComponent } from './components/subscription-applications.component';
import { SubscriptionApplicationDetailsComponent } from './components/subscription-application-details.component';

@NgModule({
  declarations: [SubscriptionApplicationsComponent,  SubscriptionApplicationDetailsComponent],
  imports: [
      CommonModule,
      SharedModule
  ]
})
export class SubscriptionApplicationsModule { }
